/**
 * SxS Network — Garage site helpers (v4, 10 Oct 2026 — welcome card asks for alerts first, hook fires after permission; v3 app welcome; v2 kept)
 * v2: "How you ride" in the search-bar garage chip (desktop + mobile) and
 *     readable chip text (theme html font-size is 10px, so the bar's rem sizes were 6.5–10.5px).
 * ---------------------------------------------------
 * Loaded on every page (snippets/meta-tags.liquid, after garage-data.js).
 *
 * 1. PREFILL forms from the garage + ride profile:
 *    - Build Concierge (/pages/build-concierge): #bhMake, #bhModel, #bhGoal
 *    - any Shopify contact form with a textarea named contact[body] (Service Quote,
 *      product-page question box): the rider line + machine line are appended once,
 *      only when the field is empty, so nothing the rider typed is overwritten.
 * 2. Nothing is sent anywhere. Garage data stays on the device.
 */
(function() {
  function G() { return window.SxSNGarage; }

  function primaryMachine() {
    var g = G(); if (!g) return null;
    return g.getPrimary() || (g.list()[0] || null);
  }

  function contextBlock() {
    var g = G(); if (!g) return '';
    var lines = [];
    var m = primaryMachine();
    if (m) lines.push('My machine: ' + g.machineLine(m));
    var extra = g.list().filter(function(x) { return !m || x.id !== m.id; });
    if (extra.length) lines.push('Also in my garage: ' + extra.map(function(x) { return g.formatLabel(x); }).join('; '));
    var rl = g.rideLine();
    if (rl) lines.push(rl);
    return lines.join('\n');
  }

  function prefillBuildConcierge() {
    var make = document.getElementById('bhMake');
    var model = document.getElementById('bhModel');
    var goal = document.getElementById('bhGoal');
    if (!make || !model || !goal) return false;
    var g = G(); if (!g) return false;
    var m = primaryMachine();
    if (m) {
      if (!make.value) {
        var opts = Array.prototype.slice.call(make.options);
        var hit = opts.find(function(o) { return o.text.trim().toLowerCase() === String(m.make).toLowerCase(); })
               || opts.find(function(o) { return o.text.toLowerCase().indexOf(String(m.make).toLowerCase()) !== -1; });
        make.value = hit ? hit.value : 'Other';
      }
      if (!model.value) {
        var parts = [];
        if (m.year) parts.push(m.year);
        parts.push(m.model);
        if (m.trim) parts.push(m.trim);
        model.value = parts.join(' ');
      }
    }
    var block = contextBlock();
    if (block && !goal.value) {
      goal.value = '\n\n— from my garage —\n' + block;
      // put the cursor at the top so the rider writes above the context
      try { goal.setSelectionRange(0, 0); } catch (e) {}
    }
    return true;
  }

  function prefillContactBodies() {
    var block = contextBlock();
    if (!block) return;
    var areas = document.querySelectorAll('textarea[name="contact[body]"]');
    Array.prototype.forEach.call(areas, function(ta) {
      if (ta.id === 'bhGoal') return; // handled above
      if (ta.value) return;
      if (ta.getAttribute('data-sxsn-prefilled')) return;
      ta.setAttribute('data-sxsn-prefilled', '1');
      ta.value = '\n\n— from my garage —\n' + block;
      try { ta.setSelectionRange(0, 0); } catch (e) {}
    });
  }

  function run() {
    if (!G()) return;
    prefillBuildConcierge();
    prefillContactBodies();
  }

  // ======================================================================
  // 3. SEARCH-BAR GARAGE CHIP — add the ride summary + a "How you ride" menu
  //    The chip itself is rendered by the header custom-liquid sections
  //    (desktop .sxs-garage-chip, mobile .sxs-mob-garage-chip). They rebuild
  //    innerHTML on every change, so we watch them and re-add our bits.
  // ======================================================================
  var INTEREST_LINKS = {
    'Lighting': '/collections/lighting', 'Audio & comms': '/collections/audio-communications',
    'Suspension': '/collections/suspension', 'Protection': '/collections/machine-protection',
    'Bumpers': '/collections/bumpers', 'Tires & wheels': '/collections/tires-and-wheels',
    'Winches': '/collections/winches', 'Windshields': '/collections/windshields',
    'Cages & roofs': '/collections/roll-cage', 'Storage': '/search?q=storage+bag',
    'Whips & flags': '/search?q=whip', 'Axles & driveline': '/collections/axles'
  };
  var RIDE_URL = '/pages/my-garage#ride';

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function shortPlace(t) { return String(t).replace(/\s*\(.*?\)\s*/g, ' ').split('/')[0].trim(); }

  /** "Trail · Rock crawling +3 · Moab +12" — fits under the machine name. */
  function rideShort() {
    var g = G(); if (!g || !g.hasProfile || !g.hasProfile()) return '';
    var p = g.getProfile();
    var bits = [];
    var st = p.styles || [];
    if (st.length) bits.push(st.slice(0, 2).join(' · ') + (st.length > 2 ? ' +' + (st.length - 2) : ''));
    var tr = (p.trails || []).slice(); if (p.other_trail) tr.push(p.other_trail);
    if (tr.length) bits.push(shortPlace(tr[0]) + (tr.length > 1 ? ' +' + (tr.length - 1) : ''));
    if (!bits.length && p.interests && p.interests.length) bits.push('Into ' + p.interests.slice(0, 2).join(', '));
    if (!bits.length && p.use) bits.push(p.use === 'both' ? 'Play + work' : p.use.charAt(0).toUpperCase() + p.use.slice(1));
    return bits.join(' · ');
  }

  function rideMenuHtml(rowClass) {
    var g = G(); if (!g) return '';
    var has = g.hasProfile && g.hasProfile();
    var p = has ? g.getProfile() : null;
    var html = '<div class="sxsn-chipride-menu">';
    html += '<div class="sxsn-chipride-head">How you ride</div>';
    if (has) {
      html += '<div class="sxsn-chipride-sum">' + esc(rideShort()) + '</div>';
      var ints = (p.interests || []).filter(function(i) { return INTEREST_LINKS[i]; }).slice(0, 6);
      if (ints.length) {
        html += '<div class="sxsn-chipride-ints">' + ints.map(function(i) {
          return '<a class="' + rowClass + ' sxsn-chipride-int" href="' + esc(INTEREST_LINKS[i]) + '">' + esc(i) + '</a>';
        }).join('') + '</div>';
      }
      html += '<a class="' + rowClass + ' sxsn-chipride-edit" href="' + RIDE_URL + '">Edit how you ride →</a>';
    } else {
      html += '<div class="sxsn-chipride-sum">Tell us where and how you ride — 60 seconds of taps. It rides along with every build request.</div>';
      html += '<a class="' + rowClass + ' sxsn-chipride-edit" href="' + RIDE_URL + '">+ Add how you ride →</a>';
    }
    return html + '</div>';
  }

  function enhanceDesktop() {
    var chip = document.querySelector('.sxs-garage-chip');
    if (!chip || chip.style.display === 'none') return;
    var info = chip.querySelector('.sxs-garage-chip-info');
    if (info && !info.querySelector('.sxsn-chipride-line')) {
      var s = rideShort();
      var line = document.createElement('div');
      line.className = 'sxsn-chipride-line' + (s ? '' : ' empty');
      line.textContent = s || '+ Add how you ride';
      info.appendChild(line);
    }
    var drop = chip.querySelector('.sxs-garage-dropdown');
    if (drop && !drop.querySelector('.sxsn-chipride-menu')) {
      var actions = drop.querySelector('.sxs-garage-action-row');
      var wrap = document.createElement('div');
      // links reuse the theme's action-row class so the chip's click handler lets them navigate
      wrap.innerHTML = rideMenuHtml('sxs-garage-action-row');
      if (actions) drop.insertBefore(wrap.firstChild, actions); else drop.appendChild(wrap.firstChild);
    }
  }

  function enhanceMobile() {
    var chip = document.querySelector('.sxs-mob-garage-chip');
    if (!chip) return;
    var info = chip.querySelector('.sxs-mob-garage-chip-info');
    if (info && !info.querySelector('.sxsn-chipride-line')) {
      var s = rideShort();
      var line = document.createElement('div');
      line.className = 'sxsn-chipride-line' + (s ? '' : ' empty');
      line.textContent = s || '+ Add how you ride';
      info.appendChild(line);
    }
    var drop = document.querySelector('.sxs-mob-garage-dropdown');
    if (drop && drop.innerHTML && !drop.querySelector('.sxsn-chipride-menu')) {
      var actions = drop.querySelector('.sxs-mob-garage-action-row');
      var wrap = document.createElement('div');
      wrap.innerHTML = rideMenuHtml('sxs-mob-garage-action-row');
      if (actions) drop.insertBefore(wrap.firstChild, actions); else drop.appendChild(wrap.firstChild);
    }
  }

  function injectChipCss() {
    if (document.getElementById('sxsn-chipride-css')) return;
    var css = ''
      // readable sizes for the existing bar (px, because html is 10px in this theme)
      + '.sxs-garage-chip-label,.sxs-mob-garage-chip-label{font-size:11px!important;}'
      + '.sxs-garage-chip-name{font-size:16px!important;}.sxs-mob-garage-chip-name{font-size:16px!important;}'
      + '.sxs-garage-dropdown-section-label,.sxs-mob-garage-dropdown-section{font-size:11px!important;}'
      + '.sxs-garage-machine-row-name{font-size:14px!important;}.sxs-garage-action-row{font-size:14px!important;}'
      // ride line under the machine name
      + '.sxsn-chipride-line{font-size:12px;line-height:1.25;color:#bbb;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:240px;margin-top:2px;}'
      + '.sxsn-chipride-line.empty{color:#ff5400;font-weight:700;}'
      // ride section in the dropdown
      + '.sxsn-chipride-menu{border-top:1px solid #2a2a2a;padding:10px 18px 12px;text-align:left;}'
      + '.sxsn-chipride-head{font-size:11px;color:#ff5400;text-transform:uppercase;letter-spacing:.1em;font-weight:900;margin-bottom:6px;}'
      + '.sxsn-chipride-sum{font-size:13px;color:#ddd;line-height:1.4;margin-bottom:8px;}'
      + '.sxsn-chipride-ints{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:8px;}'
      + 'a.sxsn-chipride-int{display:inline-block!important;padding:5px 10px!important;border:1px solid #ff5400!important;border-radius:999px;'
      +   'font-size:12px!important;font-weight:700;color:#fff!important;text-decoration:none;background:rgba(255,84,0,.12);}'
      + 'a.sxsn-chipride-int:hover{background:#ff5400;color:#000!important;}'
      + 'a.sxsn-chipride-edit{display:block;padding:6px 0 0!important;border:0!important;color:#ff5400!important;font-weight:800;font-size:14px!important;text-decoration:none;background:none!important;}';
    var st = document.createElement('style');
    st.id = 'sxsn-chipride-css';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function enhanceChips() {
    if (!G()) return;
    injectChipCss();
    enhanceDesktop();
    enhanceMobile();
  }

  function watchChips() {
    var targets = ['.sxs-garage-chip', '.sxs-mob-garage-chip', '.sxs-mob-garage-dropdown'];
    var queued = false;
    var obs = new MutationObserver(function() {
      if (queued) return;
      queued = true;
      setTimeout(function() { queued = false; enhanceChips(); }, 0);
    });
    targets.forEach(function(sel) {
      var el = document.querySelector(sel);
      if (el) obs.observe(el, { childList: true, attributes: true, attributeFilter: ['style', 'class'] });
    });
  }

  // ============================================================
  // v4 (10 Oct 2026, v7.2): APP WELCOME — first launch of the installed app (standalone mode).
  // Shows the install code immediately (no server). The welcome PUSH only makes sense once this
  // device can receive one, so the install webhook (window.SXSN_INSTALL_HOOK → Zapier → Progressier)
  // fires AFTER notification permission is granted and the device id is registered with Progressier.
  // v3 fired the hook on first paint: Progressier accepted the push but "no connected devices" (10 Oct).
  // ============================================================
  var WELCOME_KEY = 'sxsn_app_welcome_v1';
  var HOOK_KEY = 'sxsn_app_hook_sent_v1';
  function deviceId() {
    try {
      var k = 'sxsn_device_id', v = localStorage.getItem(k);
      if (!v) { v = 'dev_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); localStorage.setItem(k, v); }
      return v;
    } catch (e) { return null; }
  }
  function isStandalone() {
    try { return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true; } catch (e) { return false; }
  }
  function pushPermission() {
    try { return (window.Notification && Notification.permission) || 'unsupported'; } catch (e) { return 'unsupported'; }
  }
  function registerDevice() {
    // make sure Progressier knows this device by id (and email when logged in) BEFORE the Zap targets it
    try {
      if (!(window.progressier && typeof window.progressier.add === 'function')) return false;
      var cust = window.SxSNCustomer || null;
      var data = { id: cust ? String(cust.id) : deviceId(), tags: 'app-installed' };
      if (cust && cust.email) data.email = cust.email;
      window.progressier.add(data);
      return true;
    } catch (e) { return false; }
  }
  function fireInstallHook(reason) {
    try { if (localStorage.getItem(HOOK_KEY)) return; } catch (e) {}
    var hook = window.SXSN_INSTALL_HOOK;
    if (!(hook && /^https:\/\//.test(hook))) return;
    var cust = window.SxSNCustomer || null;
    var payload = { event: 'app_installed_first_launch', device_id: deviceId(), customer_id: cust ? String(cust.id) : null,
                    email: cust ? cust.email : null, at: new Date().toISOString(), path: location.pathname,
                    ua: navigator.userAgent.slice(0, 120), permission: pushPermission(), reason: reason || '' };
    try { localStorage.setItem(HOOK_KEY, String(Date.now())); } catch (e) {}
    try { fetch(hook, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(payload), keepalive: true }); } catch (e) {}
  }
  function afterPermissionGranted(reason) {
    // register first, give Progressier a moment to save the subscription + id, then tell the Zap
    registerDevice();
    setTimeout(function() { registerDevice(); fireInstallHook(reason); }, 2500);
  }
  function requestAlerts(btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Opening…'; }
    var done = false;
    function check(tries) {
      var p = pushPermission();
      if (p === 'granted') {
        done = true;
        if (btn) { btn.textContent = 'Alerts on ✓'; }
        afterPermissionGranted('button');
        return;
      }
      if (p === 'denied') { done = true; if (btn) { btn.disabled = false; btn.textContent = 'Alerts blocked in browser settings'; } return; }
      if (tries > 0) setTimeout(function() { check(tries - 1); }, 1000);
      else if (btn) { btn.disabled = false; btn.textContent = 'Turn on alerts'; }
    }
    try {
      var pg = window.progressier;
      if (pg && typeof pg.hardSubscribe === 'function') pg.hardSubscribe();
      else if (pg && typeof pg.subscribe === 'function') pg.subscribe();
      else if (window.Notification) Notification.requestPermission();
    } catch (e) {}
    check(90);
  }
  function appWelcome() {
    if (!isStandalone()) return;
    var perm = pushPermission();
    var firstLaunch = false;
    try { if (!localStorage.getItem(WELCOME_KEY)) { firstLaunch = true; localStorage.setItem(WELCOME_KEY, String(Date.now())); } } catch (e) {}
    // later launch, permission granted elsewhere (e.g. Progressier's own prompt) → send the hook once
    if (!firstLaunch) { if (perm === 'granted') afterPermissionGranted('later-launch'); return; }
    if (perm === 'granted') afterPermissionGranted('already-granted');
    var css = '#sxsn-welcome{position:fixed;left:12px;right:12px;bottom:12px;z-index:2147483000;background:#0f0f0f;color:#fff;border:1px solid #ff5400;border-radius:14px;padding:18px 18px 16px;box-shadow:0 12px 40px rgba(0,0,0,.45);font-family:Barlow,Inter,system-ui,sans-serif}'
      + '#sxsn-welcome h3{margin:0 0 6px;font-size:18px;line-height:1.15;color:#fff;font-family:\'Archivo Black\',Barlow,sans-serif;text-transform:uppercase;letter-spacing:.04em}'
      + '#sxsn-welcome p{margin:0 0 10px;font-size:14px;line-height:1.45;color:rgba(255,255,255,.8)}'
      + '#sxsn-welcome .code{display:inline-block;border:1px dashed #4fd36a;color:#4fd36a;font-weight:800;padding:8px 12px;border-radius:6px;font-size:16px;letter-spacing:.08em;margin:2px 0 10px}'
      + '#sxsn-welcome .row{display:flex;gap:8px;flex-wrap:wrap}'
      + '#sxsn-welcome button,#sxsn-welcome a{font:inherit;font-size:14px;font-weight:800;border-radius:6px;padding:11px 14px;cursor:pointer;text-decoration:none;border:0}'
      + '#sxsn-welcome .copy{background:#1c1c1c;color:#fff;border:1px solid #3a3a3a}#sxsn-welcome .go{background:#ff5400;color:#000}'
      + '#sxsn-welcome .alerts{background:#133a1c;color:#4fd36a;border:1px solid #4fd36a;width:100%;margin-top:8px}#sxsn-welcome .alerts:disabled{opacity:.7}'
      + '#sxsn-welcome .small{font-size:12px;color:rgba(255,255,255,.55);margin:8px 0 0}'
      + '#sxsn-welcome .x{position:absolute;top:8px;right:10px;background:none;color:rgba(255,255,255,.6);font-size:22px;padding:2px 6px}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    var box = document.createElement('div'); box.id = 'sxsn-welcome';
    var needAlerts = perm === 'default';
    box.innerHTML = '<button class="x" aria-label="Close">&times;</button>'
      + '<h3>Welcome to the SxS Network app</h3>'
      + '<p>10% off your first order over $99 — one use, this device\'s account.</p>'
      + '<div class="code" id="sxsn-welcome-code">SXSAPP10</div>'
      + '<div class="row"><button class="copy" id="sxsn-welcome-copy">Copy code</button><a class="go" href="/pages/my-garage">Set up my garage →</a></div>'
      + (needAlerts ? '<button class="alerts" id="sxsn-welcome-alerts">🔔 Turn on alerts — we\'ll send the code to your phone too</button>'
                    + '<p class="small">Only new gear for your machine and your order updates. No daily blasts.</p>' : '')
      + (window.SxSNCustomer ? '' : '<p class="small">Have an account? <a href="/account/login" style="color:#fff;padding:0;background:none;text-decoration:underline">Sign in</a> to sync your garage.</p>');
    document.body.appendChild(box);
    box.querySelector('.x').addEventListener('click', function() { box.remove(); });
    box.querySelector('#sxsn-welcome-copy').addEventListener('click', function(ev) {
      try { navigator.clipboard.writeText('SXSAPP10'); ev.target.textContent = 'Copied ✓'; } catch (e) {}
    });
    var ab = box.querySelector('#sxsn-welcome-alerts');
    if (ab) ab.addEventListener('click', function() { requestAlerts(ab); });
  }

  function start() {
    run();
    enhanceChips();
    watchChips();
    setTimeout(appWelcome, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('sxsn:garage-changed', function() { run(); setTimeout(enhanceChips, 0); });
  window.addEventListener('storage', function(e) { if (e.key === 'sxsn_garage_v1') setTimeout(enhanceChips, 0); });
})();
